export type Formats = "ncm" | "cest" | "cfop" | "cpfCnpj";

export default function format(value?: string, format?: Formats): string {
  if (!value) return "";

  switch (format) {
    case "ncm":
      return formatNcm(value);
    case "cpfCnpj":
      return formatCpfCnpj(value);
    case "cest":
      return formatCest(value);
    case "cfop":
      return formatCfop(value);
    default:
      return value;
  }
}

function formatCfop(value: string) {
  if (value.length !== 4) return value;
  return value.replace(/(\d{1})(\d{3})/, "$1.$2");
}

function formatCest(value: string) {
  if (value.length !== 7) return value;
  return value.replace(/(\d{2})(\d{3})(\d{2})/, "$1.$2.$3");
}

function formatNcm(value: string) {
  if (value.length !== 8) return value;
  return value.replace(/(\d{4})(\d{2})(\d{2})/, "$1.$2.$3");
}

function formatCpfCnpj(value: string) {
  if (value.length === 11) {
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  } else if (value.length === 14) {
    return value.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      "$1.$2.$3/$4-$5"
    );
  } else {
    return value;
  }
}
